import { css } from 'styled-components';

const displayNone = props => (props.hasContent ? '' : 'display: none;');

export const hideableRow = css`
  ${displayNone}
`;

export default css`
  ${displayNone}

  table {
    th {
      text-align: left;
    }
  }
`;
